import type { ObjectShape } from 'yup';
import * as Yup from 'yup';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFamilyMemberSignupValidationSchema = (): ObjectShape => {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      firstName: Yup.string()
        .min(2, t('mangopay.signup.form.valid.first-name'))
        .max(255, t('mangopay.signup.form.valid.first-name'))
        .required(t('mangopay.signup.form.required.first-name')),
      lastName: Yup.string()
        .min(2, t('mangopay.signup.form.valid.last-name'))
        .max(255, t('mangopay.signup.form.valid.last-name'))
        .required(t('mangopay.signup.form.required.last-name')),
      birthdate: Yup.date()
        .required(t('mangopay.signup.form.required.birthdate'))
        .typeError(t('mangopay.signup.form.valid.birthdate')),
      nationalityId: Yup.string()
        .required(t('mangopay.signup.form.required.nationality-id'))
        .typeError(t('mangopay.signup.form.valid.nationality-id')),
      countryOfResidenceId: Yup.string()
        .required(t('mangopay.signup.form.required.country-of-residence'))
        .typeError(t('mangopay.signup.form.valid.country-of-residence')),
      relationship: Yup.string().required(
        t('mangopay.signup.form.required.relationship')
      ),
      acceptTerms: Yup.boolean().test(
        'is-true',
        t('mangopay.signup.form.required.accept-terms'),
        (value) => value === true
      ),
    }),
    [t]
  );
};
